import { render, staticRenderFns } from "./PanelAdminPeriodo.vue?vue&type=template&id=73d63c6e&scoped=true"
import script from "./PanelAdminPeriodo.vue?vue&type=script&lang=js"
export * from "./PanelAdminPeriodo.vue?vue&type=script&lang=js"
import style0 from "./PanelAdminPeriodo.vue?vue&type=style&index=0&id=73d63c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d63c6e",
  null
  
)

export default component.exports